import { AppContext, BookingTool, Organisation } from "../../../AppDataProvider/AppDataProvider";
import { Button as BaseButton, List, ListItem } from "../../../common/components";
import { marginBottom, marginRight, marginTop, media, paddingBottom, typography } from "../../../common/styles";
import React, { ReactElement, useContext } from "react";
import { applyOpacity } from "../../../common/styles/utils";
import styled from "styled-components";
import { UnitOfMeasurement } from "../../../GeneratedGraphQL";
import { useTranslation } from "react-i18next";
export type OnSelectOrganisationOpts = {
  organisation: Organisation;
};
export type ListViewProps = {
  onSelectOrganisation: (options: OnSelectOrganisationOpts) => void;
  organisations: BookingTool["organisations"];
};
export function ListView(props: ListViewProps): ReactElement {
  const {
    t
  } = useTranslation();
  const {
    appData
  } = useContext(AppContext);
  const {
    organisations: organisationPage,
    onSelectOrganisation
  } = props;
  const {
    locationSelection
  } = appData.bookingTool;
  const searchAndMapEnabled = locationSelection ? locationSelection.searchAndMapEnabled : false;
  const unsortedOrganisations = organisationPage.edges.map(({
    node
  }) => node);
  const organisations = searchAndMapEnabled ? unsortedOrganisations : unsortedOrganisations.sort((a, b) => a.name.localeCompare(b.name));
  return <List data-sentry-element="List" data-sentry-component="ListView" data-sentry-source-file="ListView.tsx">
      {organisations.map((organisation, index) => {
      const name = searchAndMapEnabled ? `${index + 1}. ${organisation.name}` : organisation.name;
      const address = organisation.location?.address;
      const proximityToSearchedLocation = organisation.proximityToSearchedLocation;
      return <ListItem key={organisation._id}>
            <Content>
              <Name>{name}</Name>
              {organisation.location && <>
                  <Location>{address}</Location>
                  {proximityToSearchedLocation && <Distance>
                      <Label>{t("distance")}</Label>
                      <Value>
                        {`${proximityToSearchedLocation >= 10 ? proximityToSearchedLocation.toFixed(0) : proximityToSearchedLocation.toFixed(1)} ${appData.bookingTool.unitOfMeasurement === UnitOfMeasurement.Miles ? t("miles") : t("kilometres")}`}
                      </Value>
                    </Distance>}
                </>}
            </Content>
            <Button variant="primary" onClick={() => onSelectOrganisation({
          organisation
        })}>
              {t("select")}
            </Button>
          </ListItem>;
    })}
    </List>;
}
export default ListView;
const Content = styled.div`
  @media ${media.mobile} {
    ${paddingBottom.s}
  }
`;
const Name = styled.h2`
  ${typography.bodyBold}
  ${marginTop.zero}
  ${marginBottom.xs}
`;
const Location = styled.div`
  ${typography.body}
  ${marginBottom.xs}
`;
const Distance = styled.div`
  display: flex;
  flex-direction: row;
`;
const Label = styled.span`
  ${typography.small}
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.6)};
  ${marginRight.s}
`;
const Value = styled.span`
  ${typography.small}
`;
const Button = styled(BaseButton)`
  min-width: 6.25rem;
`;